module.exports = __webpack_public_path__ + "img/icon_chatbot_q.ba6def21.svg";